import React from "react";
import { useLocation } from "react-router-dom";
import "../style/SignIn.scss";

const logo2 = "/icons/ComputAssist Badge.png";

const InvalidLogin = () => {
  const location = useLocation();
  const reason = location.state?.reason || "This login link is invalid or has expired.";

  return (
    <div className="login">
      <div className="login-form">
        <img src={logo2} alt="ComputAssist" />
        <div className="login-step">
          <h3>Unable to Sign You In</h3>
          <p className="error-message">{reason}</p>
          <p>Please return to the originating application and try again.</p>
        </div>
      </div>
    </div>
  );
};

export default InvalidLogin;